package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.Background
import com.varabyte.kobweb.compose.css.BackgroundImage
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.lennycodes.hldi.constants.HLDITheme

val GalleryOverlayStyle = CssStyle {
    base {
        Modifier
            .position(Position.Absolute)
            .bottom(0.px)
            .left(0.px)
            .right(0.px)
            .padding(20.px)
            .backgroundImage(
                        linearGradient(
                            HLDITheme.Colors.tranparent,
                            com.varabyte.kobweb.compose.ui.graphics.Color.rgba(0, 0, 0, 0.8f)

                )
            )
            .color(HLDITheme.Colors.white)
            .opacity(0)
            .transition(
                Transition.of(
                    property = "opacity",
                    duration = 300.ms,
                    timingFunction = TransitionTimingFunction.Ease
                )
            )
    }
}